import { connect } from 'react-redux';
import { initialFetch } from './redux/actions';
import { getCanUserHaveWatchedGroups, getMainNavNewContent, getIsNetworkBarInitialized, } from './redux/selectors';
var mapStateToProps = function (state) { return ({
    showWatchedGroupsEmptyState: !getCanUserHaveWatchedGroups(state),
    mainNavItems: getMainNavNewContent(state),
    isInitialized: getIsNetworkBarInitialized(state),
}); };
var mapDispatchToProps = {
    initialFetch: initialFetch,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=NetworkBar.container.js.map